// src/components/Footer.js
import React from 'react';
import '../styles/components/Footer.css';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { Link } from "react-router-dom";


const contactNumber='+918950533327';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">

        {/* Company Introduction */}
        <div className="footer-section about">
          <h2>Flight Reservation Hub</h2>
          <p>
            Leading online travel agency specializing in affordable flights, vacation packages, and business travel solutions.
            Compare prices from 500+ airlines worldwide with instant booking, flexible cancellation, and comprehensive travel insurance.
            IATA certified with award-winning customer service and lowest price guarantee.
          </p>
        </div>

        <div className="footer-section links">
          <h2>Link</h2>
          <div className="footer-links">
            <Link to="/terms">Terms & Conditions</Link>
            <Link to="/privacyPolicy">Privacy Policy</Link>
            <Link to="/RefundPolicy">Refund Policy</Link>
            <Link to="/faq">FAQ Page</Link>
          </div>
        </div>

        {/* Contact Section */}
        <div className="footer-section contact">
          <h2>Contact Us</h2>
          <p><FaPhoneAlt className="icon" /><a href={`tel:${contactNumber}`}> {contactNumber}</a></p>
          <p><FaEnvelope className="icon" /> sahil@flightreservationhub.com</p>
          <p><FaMapMarkerAlt className="icon" /> Unit No 102, 1111, Sector 47, Sector 47, Gurugram, Gurugram, Haryana, 122018</p>
        </div>

        {/* Social Media Section */}
        <div className="footer-section social">
          <h2>Follow Us</h2>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebook className="icon" /> facebook
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaTwitter className="icon" /> twitter
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="icon" /> instagram
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="icon" /> linkedin
            </a>
          </div>
        </div>

        
      </div>
      <p className="copyright">© {new Date().getFullYear()} Flight Reservation Hub. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
